/* NORTHBITE — Bewegung und Maße (04.10.2026)
   1. misst Kopfzeile und Produkt-Überschrift, damit die Dose in den Bildschirm passt
   2. blendet Inhalte beim Scrollen ein (nur wenn <html> die Klasse nb-motion trägt)
   3. zählt die Nährwerte hoch und lässt die Dose der Maus folgen */
(function () {
  if (window.__nbMotion) return;
  window.__nbMotion = true;

  var root = document.documentElement;
  var wrap = document.querySelector('.page-wrapper');

  /* 1. Maße ---------------------------------------------------------------- */
  function measure() {
    var hd = document.querySelector('[data-ew-header]');
    if (hd) {
      var inner = hd.querySelector('.ew-hd__inner') || hd;
      var top = parseFloat(getComputedStyle(hd).top) || 0;
      root.style.setProperty('--nb-hd', Math.round(top + inner.offsetHeight) + 'px');
    }
    var prod = document.querySelector('.ew-prod');
    var media = prod && prod.querySelector('.ew-prod__media');
    if (media) {
      var head = media.getBoundingClientRect().top - prod.getBoundingClientRect().top;
      root.style.setProperty('--nb-prod-head', Math.max(0, Math.round(head)) + 'px');
    }
  }
  var mt;
  function measureSoon() { clearTimeout(mt); mt = setTimeout(measure, 120); }
  measure();
  window.addEventListener('resize', measureSoon);
  window.addEventListener('load', measure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  // Kopfzeile und Überschrift ändern ihre Höhe auch ohne Fenster-Resize (Schriften, Umbrüche)
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(measureSoon);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ew-header] .ew-hd__inner, .ew-prod__head'), function (el) { ro.observe(el); });
  }

  if (!root.classList.contains('nb-motion') || !('IntersectionObserver' in window)) return;

  /* 2. Einblenden beim Scrollen -------------------------------------------- */
  var items = [];
  function tag(el, variant, delay) {
    if (!el || el.classList.contains('nb-rv') || el.closest('[hidden]')) return;
    el.classList.add('nb-rv');
    if (variant) el.classList.add('nb-rv--' + variant);
    if (delay) el.style.setProperty('--nb-d', delay + 'ms');
    el.__nbDelay = delay || 0;
    el.__nbVariant = variant || '';
    items.push(el);
  }
  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }
  // Kinder eines Blocks nacheinander
  function stagger(containerSel, childSel, step, variant) {
    each(containerSel, function (box) {
      var kids = childSel ? box.querySelectorAll(childSel) : box.children;
      Array.prototype.forEach.call(kids, function (k, i) { tag(k, variant, Math.min(i, 7) * step); });
    });
  }

  stagger('.ew-prod__head', null, 90);
  each('.ew-prod__media .ew-media img', function (el) { tag(el, 'can', 0); });
  stagger('.ew-prod__panel', '.ew-badge, .ew-prod__name, .ew-prod__desc, .ew-prod__set, .ew-prod__price, .ew-prod__unit, .ew-prod__form > .ew-btn, .ew-prod__ship, .ew-prod__empty', 70);
  stagger('.ew-prod__facts', null, 80);

  stagger('.ew-ing__intro', null, 90);
  each('.ew-ing__facts', function (el) { tag(el, 'zoom', 120); });
  stagger('.ew-ing__grid', null, 110);
  each('.ew-ing__foot', function (el) { tag(el); });

  stagger('.ew-nut__intro', null, 90);
  each('.ew-nut__amino', function (el) { tag(el, 'zoom', 120); });
  stagger('.ew-nut__grid', null, 70);
  each('.ew-nut__foot', function (el) { tag(el); });

  stagger('.ew-calc__head', null, 90);
  stagger('.ew-calc__controls', '.ew-calc__field', 90);
  each('.ew-calc__result', function (el) { tag(el, 'r', 150); });

  stagger('.ew-chap__head', null, 90);
  stagger('.ew-chap__text', null, 80);
  each('.ew-chap__item', function (item) {
    tag(item.querySelector('.ew-chap__media'), item.classList.contains('ew-chap__item--b') ? 'l' : 'r', 80);
  });

  stagger('.ew-stmt__text', null, 110);
  each('.ew-stmt__media', function (el) { tag(el, 'zoom', 150); });

  stagger('.ew-faq__head', null, 90);
  stagger('.ew-faq__list', null, 70);

  stagger('.ew-news__text', null, 90);
  each('.ew-news__form', function (el) { tag(el, '', 150); });

  stagger('.ew-trow__in', null, 90);

  // übrige Sektionen (derzeit ausgeblendet): Überschriften und Karten
  each('.ew-wild, .ew-guide, .ew-sub, .ew-rev, .ew-trust', function (sec) {
    Array.prototype.forEach.call(sec.querySelectorAll('.ew-eyebrow, .ew-display, .ew-lead, .ew-rev__card, .ew-guide__lead, .ew-guide__item, .ew-sub__step, .ew-trust__item'), function (el, i) {
      tag(el, '', Math.min(i, 5) * 80);
    });
  });

  function done(el) {
    el.classList.remove('nb-rv', 'nb-rv--l', 'nb-rv--r', 'nb-rv--zoom', 'nb-rv--can', 'is-in');
    el.style.removeProperty('--nb-d');
    if (el.__nbVariant === 'can') el.classList.add('nb-float');
  }
  function show(el, now) {
    if (el.__nbShown) return;
    el.__nbShown = true;
    if (io) io.unobserve(el);
    if (now) el.style.setProperty('--nb-d', '0ms');
    el.classList.add('is-in');
    if (el.classList.contains('ew-ing__facts')) countUp(el);
    setTimeout(function () { done(el); }, (now ? 0 : el.__nbDelay) + (el.__nbVariant === 'can' ? 1300 : 950));
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) show(e.target);
      else if (e.boundingClientRect.bottom < 0) show(e.target, true); // liegt schon oberhalb
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
  items.forEach(function (el) { io.observe(el); });

  // Sicherheitsnetz: am Seitenende und beim Drucken ist alles sichtbar
  function showAll() { items.forEach(function (el) { show(el, true); }); }
  function atEnd() {
    var sc = (wrap && wrap.scrollHeight > wrap.clientHeight + 4) ? wrap : (document.scrollingElement || root);
    if (sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 8) showAll();
  }
  window.addEventListener('scroll', atEnd, { passive: true });
  if (wrap) wrap.addEventListener('scroll', atEnd, { passive: true });
  window.addEventListener('beforeprint', showAll);

  /* 3a. Nährwerte hochzählen ------------------------------------------------ */
  function countUp(box) {
    Array.prototype.forEach.call(box.querySelectorAll('dd'), function (dd) {
      var full = dd.textContent;
      var m = full.match(/\d+(?:[.,]\d+)?/);
      if (!m) return;
      var raw = m[0];
      var sep = raw.indexOf(',') > -1 ? ',' : (raw.indexOf('.') > -1 ? '.' : '');
      var dec = sep ? raw.split(sep)[1].length : 0;
      var end = parseFloat(raw.replace(',', '.'));
      if (!isFinite(end)) return;
      var before = full.slice(0, m.index), after = full.slice(m.index + raw.length);
      var t0 = null, dur = 1300;
      function frame(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = (end * eased).toFixed(dec);
        if (sep === ',') val = val.replace('.', ',');
        dd.textContent = p < 1 ? before + val + after : full;
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }

  /* 3b. Dose folgt der Maus -------------------------------------------------- */
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fine) {
    each('.ew-prod__media', function (pm) {
      pm.addEventListener('pointermove', function (e) {
        var r = pm.getBoundingClientRect();
        pm.style.setProperty('--nb-tx', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
        pm.style.setProperty('--nb-ty', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
      });
      pm.addEventListener('pointerleave', function () {
        pm.style.setProperty('--nb-tx', '0');
        pm.style.setProperty('--nb-ty', '0');
      });
    });
  }
})();
